export default {
  en: {
    haveAccount: 'Already have an account?',
    signIn: 'Sign in',
    title: 'Welcome to {{appName}}',
    subtitle: 'Here you learn a language by talking',
  },
  ru: {
    haveAccount: 'Уже есть аккаунт?',
    signIn: 'Войти',
    title: 'Добро пожаловать в {{appName}}',
    subtitle: 'Тут учат язык за разговором',
  },
  de: {
    title: 'Willkommen bei {{appName}}',
    subtitle: 'Hier lernt man Sprachen im Gespräch',
  },
  pt: {
    title: 'Boas-vindas ao {{appName}}',
    subtitle: 'Aqui se aprende idioma conversando',
  },
  fr: {
    title: 'Bienvenue sur {{appName}}',
    subtitle: 'Ici, on apprend une langue en discutant',
  },
  es: {
    title: 'Te damos la bienvenida a {{appName}}',
    subtitle: 'Aquí se aprende un idioma conversando',
  },
};
